const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const UIModal = require('app/ui/Modal');

class Modal {

    defaultOptions() {
        return {
            'id': 'searchModal',
            'search': null,
            'limit': 25,
            'onClose': function(event){},
            'onShown': function(event){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSearch = this.onSearch.bind(this);

        this.limit = this.settings.limit;
        this.search = this.settings.search;
        if(!this.search){
            window.notify("Missing search parameter in SearchModal","danger");
        }
        this.title = window.translate('app.search.title');

        this.$inputSearch = $('<input/>')
        .attr('type',"text")
        .addClass('form-control')
        .val(this.search);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$inputSearch.on('change',this.onSearch);
        window.bindAutocomplete(this.$inputSearch,this.onSearch,500);

        this.build();
    }

    onSearch(event){
        if(event){
            event.stopPropagation();
            event.preventDefault();
        }
        this.refresh();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('search-modal');

        this.modal = new UIModal({
            'id': this.settings.id,
            'title': this.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "full",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildContent();

        this.modal.show();
    }

    refresh(){
        if(this.search != this.$inputSearch.val()){
            this.search = this.$inputSearch.val();
            window.App.setGlobalSearch(this.search);
            this.loadData();
        }
    }

    show(){
        this.modal.show();
        return this;
    }

    hide(){
        this.modal.hide();
        return this;
    }

    toggle(){
        this.modal.toggle();
        return this;
    }

    dispose(){
        this.modal.dispose();
        return this;
    }

    destroy(){
        this.modal.destroy();
        return this;
    }

    buildContent(){
        this.$filterContainer = $("<div/>")
        .addClass('d-flex justify-content-center')
        .append(
            $('<div/>')
            .addClass('w-100 p-1')
            .append(this.$inputSearch)
        );


        this.$resultContainer = $('<div/>')
        .append(window.App.generateLoader());
        this.$content
        .append(this.$filterContainer)
        .append("<hr/>")
        .append(this.$resultContainer);

        this.loadData();
    }

    loadData(){
        var self = this;

        if(this.search.length > 2){
            this.$resultContainer
            .html('')
            .append(window.App.generateLoader());

            let queries = [
                this.buildRestaurantQuery(),
                this.buildOrderQuery(),
                this.buildProductQuery(),
            ];

            let query = new GraphQLMultiQuery({
                //parameters
                'queries': queries,

                //callbacks
                'before': function(){
                },
                'success': function(data){
                    self.buildResults(data);
                },
                'error': function(message, data){
                    console.error(message,data);
                    window.notify(message,"danger");
                },
                'after': function(){
                }
            });

            query.execute();
        }else{
            this.$resultContainer
            .html('')
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(
                    $('<div/>')
                    .addClass('alert alert-warning')
                    .append(window.translate('app.search.tooTinySearch'))
                )
            );
        }

    }

    buildRestaurantQuery(){
        var self = this;

        let parameters = {
            'filter': {
                'search': this.search,
            },
            'first': this.limit,
            'orderBy': 'name',
            'dir': "ASC",
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurants',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }


    buildOrderQuery(){
        var self = this;

        let filter = {
            'search': this.search,
        };
        let search = this.search;
        if(search.startsWith('BL')){
            let potentielDeliveryNumber = search.replace('BL','').trim();
            if(!isNaN(potentielDeliveryNumber)){
                filter = {
                    'deliveryNumber': potentielDeliveryNumber
                };
            }
        }

        let parameters = {
            'filter': filter,
            'first': this.limit,
            'orderBy': 'createdAt',
            'dir': "DESC",
        };

        let fields = [
            'id',
            'restaurant {  name }',
            'supplier { name }',
            'total',
            'createdAt',
            'deliveryNumber',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantOrders',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildProductQuery(){
        var self = this;

        let parameters = {
            'filter': {
                'search': this.search,
            },
            'first': this.limit,
            'orderBy': 'reference',
            'dir': "ASC",
        };

        let fields = [
            'id',
            'number',
            'reference',
            'supplier { name }',
            'range { name }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    buildResults(data){
        this.restaurants = data.restaurants.edges;
        this.orders = data.restaurantOrders.edges;
        this.products = data.supplierProducts.edges;


        this.$restaurantResultContainer = $('<div/>')
        .addClass('col-4 p-4')
        .addClass('search-result-container search-result-container-restaurant');
        this.$productsContainer = $('<div/>')
        .addClass('col-4 p-4')
        .addClass('search-result-container search-result-container-product');
        this.$ordersContainer = $('<div/>')
        .addClass('col-4 p-4')
        .addClass('search-result-container search-result-container-order');


        this.$resultContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(this.$restaurantResultContainer)
            .append(this.$productsContainer)
            .append(this.$ordersContainer)
        );

        this.fillRestaurantResults();
        this.fillOrderResults();
        this.fillProductResults();
    }

    fillRestaurantResults(){
        this.$restaurantResultContainer.html('');

        let $title = $('<h6/>')
        .addClass('search-title')
        .append(window.translate('app.search.restaurants.title',{'%nbResults%':this.restaurants.length}));

        let $list = $('<ul/>')
        .addClass('list-group');

        if(this.restaurants.length <= 0){
            $list
            .append(
                $('<li/>')
                .addClass('list-group-item search-list-item search-result search-result-restaurant')
                .append(window.translate('app.search.noResult'))
            );
        }else{
            for(var i in this.restaurants){
                let restaurant = this.restaurants[i];
                let $item = this.buildRestaurantItem(restaurant.node);

                $list
                .append(
                    $('<li/>')
                    .addClass('list-group-item search-list-item')
                    .append($item)
                );

            }
        }


        this.$restaurantResultContainer
        .append($title)
        .append($list);

    }

    fillOrderResults(){
        this.$ordersContainer.html('');

        let $title = $('<h6/>')
        .addClass('search-title')
        .append(window.translate('app.search.orders.title',{'%nbResults%':this.orders.length}));

        let $list = $('<ul/>')
        .addClass('list-group');

        if(this.orders.length <= 0){
            $list
            .append(
                $('<li/>')
                .addClass('list-group-item search-list-item search-result search-result-order')
                .append(window.translate('app.search.noResult'))
            );
        }else{
            for(var i in this.orders){
                let order = this.orders[i];
                let $item = this.buildOrderItem(order.node);

                $list
                .append(
                    $('<li/>')
                    .addClass('list-group-item search-list-item')
                    .append($item)
                );

            }
        }


        this.$ordersContainer
        .append($title)
        .append($list);
    }

    fillProductResults(){
        this.$productsContainer.html('');

        let $title = $('<h6/>')
        .addClass('search-title')
        .append(window.translate('app.search.products.title',{'%nbResults%':this.products.length}));

        let $list = $('<ul/>')
        .addClass('list-group search-list');
        if(this.products.length <= 0){
            $list
            .append(
                $('<li/>')
                .addClass('list-group-item search-list-item search-result search-result-product')
                .append(window.translate('app.search.noResult'))
            );
        }else{
            for(var i in this.products){
                let product = this.products[i];
                let $item = this.buildProductItem(product.node);

                $list
                .append(
                    $('<li/>')
                    .addClass('list-group-item search-list-item')
                    .append($item)
                );

            }
        }

        this.$productsContainer
        .append($title)
        .append($list);

    }

    buildRestaurantItem(restaurant){

        let $title = $('<div/>')
        .addClass('search-result-title')
        .append(restaurant.name);

        let $links = $('<ul/>')
        .addClass('list-inline btn-list-inline');

        let btns = [];

        let urlEdit = window.App.get('restaurantShowBaseUrl').replace('__ID__',restaurant.id);
        let $btnEdit = $('<a/>')
        .attr('href',urlEdit)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.edit.label'))
        .append(
            $('<i/>')
            .addClass('far fa-edit')
        );
        btns.push($btnEdit);

        let urlAnalyse = window.App.get('restaurantAnalyseBaseUrl').replace('__ID__',restaurant.id);
        let $btnAnalyse = $('<a/>')
        .attr('href',urlAnalyse)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.analyse.label'))
        .append(
            $('<i/>')
            .addClass('far fa-chart-pie')
        );
        btns.push($btnAnalyse);

        let urlUser = window.App.get('restaurantUsersBaseUrl').replace('__ID__',restaurant.id);
        let $btnUser = $('<a/>')
        .attr('href',urlUser)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.user.label'))
        .append(
            $('<i/>')
            .addClass('far fa-users')
        );
        btns.push($btnUser);

        let urlSupplier = window.App.get('restaurantSupplierBaseUrl').replace('__ID__',restaurant.id);
        let $btnSupplier = $('<a/>')
        .attr('href',urlSupplier)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.supplier.label'))
        .append(
            $('<i/>')
            .addClass('far fa-truck')
        );
        btns.push($btnSupplier);

        let urlBookmark = window.App.get('restaurantBookmarkBaseUrl').replace('__ID__',restaurant.id);
        let $btnBookmark = $('<a/>')
        .attr('href',urlBookmark)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.bookmark.label'))
        .append(
            $('<i/>')
            .addClass('far fa-star')
        );
        btns.push($btnBookmark);

        let urlCopy = window.App.get('restaurantCopyBaseUrl').replace('__ID__',restaurant.id);
        let $btnCopy = $('<a/>')
        .attr('href',urlCopy)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.copy.label'))
        .append(
            $('<i/>')
            .addClass('far fa-copy')
        );
        btns.push($btnCopy);

        let urlStat = window.App.get('restaurantStatBaseUrl').replace('__ID__',restaurant.id);
        let $btnStat = $('<a/>')
        .attr('href',urlStat)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.stat.label'))
        .append(
            $('<i/>')
            .addClass('far fa-chart-line')
        );
        btns.push($btnStat);

        let urlTrame = window.App.get('restaurantTrameBaseUrl').replace('__ID__',restaurant.id);
        let $btnTrame = $('<a/>')
        .attr('href',urlTrame)
        .addClass('btn btn-link text-dark')
        .attr('title',window.translate('restaurant.actions.trame.label'))
        .append(
            $('<i/>')
            .addClass('far fa-search')
        );
        btns.push($btnTrame);

        for(var i in btns){
            let $btn = btns[i];
            $links.append(
                $('<li/>')
                .addClass('list-inline-item')
                .append($btn)
            );
        }

        let $item = $('<div/>')
        .addClass('search-result')
        .append($title)
        .append($links);

        return $item;
    }

    buildOrderItem(order){

        let $title = $('<div/>')
        .addClass('search-result-title')
        .append(
            window.translate(
                'app.search.orders.name',
                {
                    '%orderId%': order.id,
                    '%restaurantName%': order.restaurant.name
                }
            )
        );

        let bl = '';
        if(order.deliveryNumber && order.deliveryNumber != 'NONE'){
            bl = "BL N°"+order.deliveryNumber;
        }
        let total = window.translate('total') + ' ' + window.formatFloat(order.total) + ' &euro;';

        let $supplier = $('<div/>')
        .addClass('search-result-subtitle')
        .append(order.supplier.name);
        if(bl){
            $supplier
            .append(' | ')
            .append(bl);
        }
        $supplier
        .append(' | ')
        .append(total);

        let $date = $('<div/>')
        .addClass('search-result-subtitle')
        .append(
            window.translate(
                'app.search.orders.createdAt',
                {
                    '%date%': window.formatDate(order.createdAt,window.translate('momentDateFormat.fullDayTime')),
                }
            )
        );

        let url = window.App.get('orderShowBaseUrl').replace('__ID__',order.id)
        let $link = $('<button/>')
        //.attr('href',url)
        .addClass('btn-order-show')
        .attr('data-orderid',order.id)
        .addClass('btn btn-link text-dark float-end')
        .append(
            $('<i/>')
            .addClass('far fa-edit')
        )

        let $item = $('<div/>')
        .addClass('search-result')
        .append($title)
        .append($supplier)
        .append($date)
        .append($link);

        return $item;
    }

    buildProductItem(product){

        let $title = $('<div/>')
        .addClass('search-result-title')
        .append(product.number)
        .append(' - ')
        .append(product.reference);

        let $supplier = $('<div/>')
        .addClass('search-result-subtitle')
        .append(product.supplier.name)
        .append(' | ')
        .append(product.range.name)

        let url = window.App.get('productShowBaseUrl').replace('__ID__',product.id)
        let $link = $('<a/>')
        .attr('href',url)
        .addClass('btn btn-link text-dark float-end')
        .append(
            $('<i/>')
            .addClass('far fa-edit')
        )

        let $item = $('<div/>')
        .addClass('search-result')
        .append($title)
        .append($supplier)
        .append($link);

        return $item;
    }
}

module.exports = Modal;

